export function convertDate(date) {
  var d = new Date(date);
  var day = ["Minggu", "Senin", "Selasa", "Rabu", "Kamis", "Jumat", "Sabtu"];
  var month = [
    "Januari",
    "Februari",
    "Maret",
    "April",
    "Mei",
    "Juni",
    "Juli",
    "Agustus",
    "September",
    "Oktober",
    "November",
    "Desember"
  ];
  return `${day[d.getDay()]}, ${d.getDate()} 
      ${month[d.getMonth()]} ${d.getFullYear()}`;
}

export function excerpt(html) {
  var text = html.substring(0, 500);
  var lastTagIndex = text.lastIndexOf("<");
  if (lastTagIndex != -1 && lastTagIndex > 400) {
    return text.substring(0, lastTagIndex);
  }
  return text;
}
